
export const Experience = () => {
  return (
    <>
      <section className="experience">
        <div className="_expWrapper">
          <article className="_expText">
            <h1 className="h1BG">
              Over the
              <br />
              past 05 years,
            </h1>

            <p>
              I've built products for companies and individuals around africa
              ranging from office Management websites to complex solutions and
              enterprise apps with focus on fast, elegant and accessible user
              experiences.
            </p>

            <p>
              Currently, I work at Quotemixer as the Lead frontend engineer
              crafting thoughtful and inclusive experiences that adhere to web
              standards.
            </p>

            <p>
              Before now, I worked as a Frontend Engineering at Dekilance, where
              I worked on integrating Figma UI design to interactives codes for
              organizations and individuals.
            </p>

            <p>
              Prior to Dekilance, I was once a voluteer at Techsemester,
              creating awareness to people interested in tech, overall serving
              as a guide to them in the tech space.
            </p>

            <p>
              I also have the abilities of communicating with the blockchain via
              smart contracts and integrating them to the frontend via web3 Js.
            </p>
          </article>

          <figure>
            {/* <img src={stacked} alt="" /> */}
          </figure>
        </div>
      </section>
    </>
  );
};
